// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d345df2","239":"6cc48eab","453":"a04ae9d0","455":"f088d15a"}[chunkId] + ".chunk.js";
};